<template>
    <div>
        <el-upload
            ref="upload"
            action=""
            class="upload_box"
            :multiple="false"
            :show-file-list="false"
            :file-list="fileList"
            :on-change="onChange"
            :auto-upload="false"
            accept="image/png, image/jpeg"
        >
            <div class="btn_box">
                <div v-if="imageUrl" class="img_box">
                    <img :src="imageUrl" class="avatar" />
                    <p v-if="uploadStatus == 0" class="edit_tip">正在上传</p>
                    <p v-if="uploadStatus == 1" class="edit_tip">上传成功</p>
                    <p v-if="uploadStatus == -1" class="edit_tip">上传失败</p>
                </div>
                <i
                    v-else
                    slot="trigger"
                    class="el-icon-plus avatar-uploader-icon"
                ></i>
            </div>
        </el-upload>
        <ModalImageCrop
            fixed
            :originImgUrl="originImgUrl"
            :dialogVisible="dialogVisible"
            :fixedNumber="[1, 1]"
            @success="cropSuccess"
            @cancel="cancel"
        />
    </div>
</template>

<script>
import ModalImageCrop from './ModalImageCrop.vue';
import { uploadFile } from '../../Api';

export default {
    name: 'CropImageAndUpload',
    components: {
        ModalImageCrop,
    },
    props: ['value'],
    data() {
        return {
            fileList: [],
            dialogVisible: false,
            imageUrl: '',
            uploadedUrl: '',
            percent: 0,
            uploadStatus: -1,
        };
    },
    model: {
        prop: "value", //绑定的值，通过父组件传递
        event: "update" //自定义事件名
    },

    computed: {
        originImgUrl: {
            get() {
                return this.value ? this.value.url : '';
            },
            set(val) {
                this.value = {
                    url: val,
                    filename: ''
                };
            }
        }
    },


    methods: {
      customUpload(blobData) {
        const _this = this;
        _this.uploadStatus = 0;
        uploadFile(blobData).then(res => {
          if (res.code == 0 && res.data) {
            _this.uploadStatus = 1;
            _this.$emit('update', res.data);
          }
        });
      },
        // customUpload(blobData) {
        //     const _this = this;
        //     const url = '//a.ajmide.com/business/file_upload.php';
        //     const form = new FormData();
        //     form.append('file', blobData);

        //     const xhr = new XMLHttpRequest();

        //     xhr.open('post', url, true);

        //     xhr.onload = function() {
        //         if (xhr.status < 200 || xhr.status >= 300) {
        //             console.log('onerror');
        //             _this.uploadStatus = -1;
        //             return;
        //         }

        //         const text = xhr.responseText || xhr.response;
        //         let response = null;
        //         if (!text) {
        //             return text;
        //         }
        //         try {
        //             response = JSON.parse(text);
        //         } catch (e) {
        //             response = text;
        //         }

        //         if (
        //             response &&
        //             response.code == 0 &&
        //             response.data &&
        //             response.data.url
        //         ) {
        //             _this.uploadStatus = 1;
        //             _this.$emit('update', response.data);
        //         }
        //     };
        //     xhr.onerror = function() {
        //         console.log('onerror');
        //         _this.uploadStatus = -1;
        //     };
        //     xhr.upload.onprogress = function(e) {
        //         _this.uploadStatus = 0;
        //         if (e.total > 0) {
        //             _this.percent = ((e.loaded / e.total) * 100).toFixed(0);
        //         }
        //         console.log('onprogress', _this.percent);
        //     };

        //     xhr.send(form);
        //     _this.percent = 0;
        // },

        cropSuccess(imgData) {
            console.log('cropSuccess', imgData);
            this.dialogVisible = false;
            this.imageUrl = imgData.img;
            this.customUpload(imgData.blobData);
        },

        cancel() {
            this.dialogVisible = false;
        },

        onChange(file) {
            console.log('onChange', file);
            if (this.originImgUrl != URL.createObjectURL(file.raw)) {
                  this.originImgUrl = URL.createObjectURL(file.raw);
                  this.dialogVisible = true;
              }
        },
        beforeUpload(file) {
            if (file.size <= 1024 * 1024 * 5) {
                return true;
            } else {
                this.$alert('文件大小不能超过5M');
                this.$refs.upload.clearFiles();
                return false;
            }
        },
    },
};
</script>

<style scoped>
.upload_box{
  line-height: 1;
}
.btn_box {
    width: 100px;
    height: 100px;
    /* border: 1px solid #d9d9d9; */
    border-radius: 6px;
    overflow: hidden;
    background: #F4F3F2;
}
.btn_box .el-icon-plus {
    height: 100px;
    width: 100px;
    line-height: 100px;
    font-weight: bold;
    color: #CEC2AF;
}
.img_box {
    position: relative;
}
.edit_tip {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    color: #ffffff;
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
}
.avatar {
    width: 100px;
    height: 100px;
}
</style>
